import { Component, OnInit, ViewChild, AfterViewInit, AfterContentInit } from '@angular/core';
import { AdmissionWizardService, AdmissionAdmitedWizardService } from '../../../services/wizard/admission/admission.wizzard.service';
import { AdmissionService } from '../../../services/admission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { AdmissionSearchItem } from '../../../model/admission-search-item';
import { MatTabGroup } from '@angular/material';
import { AdmissionMedicalOrder } from '../../../model/admission';
import { AdmissionPatientComponent } from '../admission-patient/admission-patient.component';
import { AdmissionValorizationComponent } from '../admission-valorization/admission-valorization.component';
import { AdmissionMedicalOrderComponent } from '../admission-medical-order/admission-medical-order.component';
import { finalize } from 'rxjs/operators';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { WizardStep } from '../../../wizard/wizard.component';
import { AdmissionOperationComponent } from '../admission-operation/admission-operation.component';
import { AuthService } from '../../../services/auth.service';
import { PatientView } from '../../../model/patient/patient-view';
import { MedicalAppointmentProcedure } from '../../../model/medical-appointment-procedure';

@Component({
  selector: 'app-admission-wizard-component',
  templateUrl: './admission-wizard.component.html',
  styleUrls: ['./admission-wizard.component.css'],
  providers: [{ provide: AdmissionWizardService, useClass: AdmissionAdmitedWizardService }]
})
export class AdmissionWizardComponent implements OnInit, AfterContentInit {

  @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
  loadingAction: boolean;
  medicalorderId: number;
  medicalAppointmentId: number;

  protocol: string;
  loading: boolean;
  readOnly: boolean;
  index = 0;

  @ViewChild('admissionPatientComponent', {static: false}) admissionPatientComponent: AdmissionPatientComponent;
  @ViewChild('admissionValorizacionComponent', {static: false}) admissionValorizacionComponent: AdmissionValorizationComponent;
  @ViewChild('admissionMedicalOrderComponent', {static: false}) admissionMedicalOrderComponent: AdmissionMedicalOrderComponent;
  @ViewChild('admissionOperationComponent', {static: false}) admissionOperationComponent: AdmissionOperationComponent;

  constructor(private admissionService: AdmissionService
    , private admissionWizardService: AdmissionWizardService
    , private menuService: MenuService
    , private authService: AuthService
    , private notificationToastService: NotificationToastService
    , public router: Router
    , private route: ActivatedRoute) {
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
    if (this.admissionPatientComponent
      && this.admissionPatientComponent.isInit) {
      steps.push(this.admissionPatientComponent);
    }
    if (this.admissionValorizacionComponent
      && this.admissionValorizacionComponent.isInit) {
      steps.push(this.admissionValorizacionComponent);
    }
    if (this.admissionMedicalOrderComponent
      && this.admissionMedicalOrderComponent.isInit) {
      steps.push(this.admissionMedicalOrderComponent);
    }
    return steps;
  }

  get patient(): PatientView  { return this.admissionWizardService.patient; }
  get procedures(): MedicalAppointmentProcedure[]  {
    if (this.admissionWizardService
      .admission == null)
      return [];

    if (this.admissionWizardService
      .admission.AdmissionValorization == null)
      return [];

      if (this.admissionWizardService
        .admission.AdmissionValorization.ValorizationEdit == null)
        return [];

        if (this.admissionWizardService
          .admission.AdmissionValorization
          .ValorizationEdit.ValorizationAmount == null)
          return [];

    return this.admissionWizardService
      .admission.AdmissionValorization
      .ValorizationEdit.ValorizationAmount
      .ValorizationItemsAmount.map(v => v.ValorizationItem.MedicalAppointmentProcedure); }

  async finish() {
    try {
      if (!this.validateSteps(this.getSteps().length - 1)) {
        this.loadingAction = true;
        await this.admissionWizardService.finish();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Admisión');
    } finally {
      this.loadingAction = false;
    }
  }

  cancel(): void {
    this.router.navigate(['admission-search']);
  }

  selectedIndexChange(newIndex: number) {
    this.validateSteps(newIndex);
    const steps = this.getSteps();
    if (steps.length > newIndex) {
      steps[newIndex].activate();
    }
  }

  private validateSteps(newIndex: number): boolean {

    const steps = this.getSteps();
    let inx = 0;
    let hasError = false;
    while (inx <= newIndex && steps.length > inx && !hasError) {
      hasError = !steps[inx].completed;
      inx = inx + 1;
    }

    if (hasError) {
      this.tabGroup.selectedIndex = inx - 1;
    }

    return hasError;
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      try {

        this.readOnly = params['ReadOnly'] === 'false' ? false : true;

        if (!this.readOnly) {
          this.menuService.setMenuTitle('Admisión', 'Edición');
        } else {
          this.admissionWizardService.setReadOnly();
          this.menuService.setMenuTitle('Admisión', 'Visualización');
        }

        this.loading = true;
        this.medicalAppointmentId = params['MedicalApponitmentId'];
        this.protocol = params['Protocol'];
        const admission = await this.admissionService.getAdmission(this.medicalAppointmentId);
        this.admissionWizardService.initialize(admission);
        this.medicalorderId = admission.AdmissionMedicalOrder.MedicalOrderEdit.MedicalOrder.Id;

      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Admisión');
      } finally {
        this.loading = false;
      }

      // esto esta re mal...
      setTimeout(() => {
        // cuando revalorizo activo nuevamente la orden por posibles cambios en valores y validador
        this.admissionValorizacionComponent.onRecalculate.subscribe(() => {
          this.admissionMedicalOrderComponent.activate();
        });
        this.admissionOperationComponent.setMedicalOrderOperation(this.medicalorderId
          , this.protocol, this.medicalAppointmentId);
        this.admissionPatientComponent.activate();
        if (this.admissionValorizacionComponent.isInit) {
          this.admissionValorizacionComponent.activate().then(() => {
            this.admissionMedicalOrderComponent.activate();
          });
        }
      }, 0);

    });
  }

  ngAfterContentInit(): void {

  }
}
